import { Controller } from '@hotwired/stimulus'
import LoggingMixin from 'lib/logging-mixin'

export default class extends LoggingMixin(Controller) {
  connect () {
    super.connect()
    this.constructor._log_name = [this.identifier, this.element]
  }
}
